module.exports = __webpack_public_path__ + "media/images/sp/brands/common/logo_an-6e72d1511afdf6b6c65d42b2e43fd1b1.svg";